// extracted by mini-css-extract-plugin
export default {"filter-checkbox-group":"IsAr","filterCheckboxGroup":"IsAr","label-filter-button":"TmKX","labelFilterButton":"TmKX"};